import { calcTotals } from "./builderHelpers.js";
import { draftByteLength, DRAFT_MAX_BYTES } from "./draftRecord.js";
import { snapshotQuoteForVersion } from "./quoteVersions.js";

/* The one version the box keeps per editing session (docs/quotes/ai-box-plan.md,
   "Version history"): the first Apply on a quote that has a saved record snapshots that
   saved record, with its total recomputed from its own lines, so history can't show one
   figure and restore another. A session flag on the builder quote stops a second one (a
   `_` key: never saved, never part of the content signature). An Amend that already took
   its snapshot this session (the last version is an amend snapshot the record doesn't
   hold yet) stops it too. */

const unsavedAmendSnapshot = (quote, savedRecord) => {
  const versions = quote?.versions || [];
  const last = versions[versions.length - 1];
  return !!last && last.source === "amend" && versions.length > (savedRecord?.versions || []).length;
};

export const boxWantsSnapshot = (quote, savedRecord) => !!savedRecord && !quote?._boxSnapshotTaken && !unsavedAmendSnapshot(quote, savedRecord);

const buildSnapshot = (savedRecord) => {
  const { total } = calcTotals(savedRecord.lineItems || [], savedRecord.quoteDiscounts || []);
  return snapshotQuoteForVersion({ ...savedRecord, total }, { source: "ai-edit", note: "Before the first AI box change" });
};

export function boxSnapshotPatch(quote, savedRecord) {
  if (!boxWantsSnapshot(quote, savedRecord)) return {};
  return { versions: [...(quote.versions || []), buildSnapshot(savedRecord)], _boxSnapshotTaken: true };
}

/** A snapshot copies the original email, notes and extracted text, so one per session
 *  doesn't bound a document's size. Refused on screen before anything changes.
 *  `next` is the quote as Apply would leave it (commitBoxPlan). */
export function boxSnapshotRefusal(quote, next, savedRecord) {
  if (!boxWantsSnapshot(quote, savedRecord)) return "";
  const withVersion = { ...next, ...boxSnapshotPatch(quote, savedRecord) };
  const { dataUrl: _d, ...rest } = withVersion;
  const lean = { ...rest, attachments: (withVersion.attachments || []).map(({ dataUrl: _u, file: _f, bytes: _b, ...a }) => a) };
  if (draftByteLength(lean) <= DRAFT_MAX_BYTES) return "";
  return "This quote is too large to keep a version of the change, so nothing was applied. Hand edits still work.";
}

/** The saved record behind the open quote. DataContext hands out active quotes and drafts
 *  as two lists, and a saved draft has a saved record like any other. */
export const findSavedRecord = (id, savedQuotes, draftQuotes) =>
  (savedQuotes || []).find((sq) => sq.id === id) || (draftQuotes || []).find((sq) => sq.id === id) || null;
